/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */

export function TicketsIcon({ style }) {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      viewBox="0 0 24 16"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M11.5 4.5H9.5V2.5H11.5V4.5ZM11.5 9H9.5V7H11.5V9ZM11.5 13.5H9.5V11.5H11.5V13.5ZM20.5 6V2C20.5 0.89 19.6 0 18.5 0H2.5C1.96957 0 1.46086 0.210714 1.08579 0.585786C0.710714 0.960859 0.5 1.46957 0.5 2V6C1.61 6 2.5 6.9 2.5 8C2.5 8.53043 2.28929 9.03914 1.91421 9.41421C1.53914 9.78929 1.03043 10 0.5 10V14C0.5 14.5304 0.710714 15.0391 1.08579 15.4142C1.46086 15.7893 1.96957 16 2.5 16H18.5C19.0304 16 19.5391 15.7893 19.9142 15.4142C20.2893 15.0391 20.5 14.5304 20.5 14V10C19.9696 10 19.4609 9.78929 19.0858 9.41421C18.7107 9.03914 18.5 8.53043 18.5 8C18.5 7.46957 18.7107 6.96086 19.0858 6.58579C19.4609 6.21071 19.9696 6 20.5 6Z"
        fill={style.color}
      />
    </svg>
  );
}

export function VoucherIcon({ style }) {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      viewBox="0 0 24 16"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V6C1.11 6 2 6.9 2 8C2 8.53043 1.78929 9.03914 1.41421 9.41421C1.03914 9.78929 0.530433 10 0 10V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14V10C19.4696 10 18.9609 9.78929 18.5858 9.41421C18.2107 9.03914 18 8.53043 18 8C18 6.89 18.9 6 20 6V2C20 0.89 19.1 0 18 0H2ZM13.5 3L15 4.5L6.5 13L5 11.5L13.5 3ZM6.81 3.04C7.79 3.04 8.58 3.83 8.58 4.81C8.58 5.27943 8.39352 5.72964 8.06158 6.06158C7.72964 6.39352 7.27943 6.58 6.81 6.58C5.83 6.58 5.04 5.79 5.04 4.81C5.04 4.34057 5.22648 3.89036 5.55842 3.55842C5.89036 3.22648 6.34057 3.04 6.81 3.04ZM13.19 9.42C14.17 9.42 14.96 10.21 14.96 11.19C14.96 11.6594 14.7735 12.1096 14.4416 12.4416C14.1096 12.7735 13.6594 12.96 13.19 12.96C12.21 12.96 11.42 12.17 11.42 11.19C11.42 10.7206 11.6065 10.2704 11.9384 9.93842C12.2704 9.60648 12.7206 9.42 13.19 9.42Z"
        fill={style.color}
      />
    </svg>
  );
}
